import { Button, Tooltip } from "@material-ui/core";
import React, { useRef, useState, useEffect, useCallback } from "react";
import ReactPlayer from "react-player";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Forward5Icon from '@material-ui/icons/Forward5';
import IconButton from '@material-ui/core/IconButton'; import Replay5Icon from '@material-ui/icons/Replay5';
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import Divider from '@material-ui/core/Divider';

const CMSyncedVideoPlay = ({ scenarioName, videoUrls, closeDialog }) => {
  console.log("Video urls inside video component", videoUrls)
  const players = useRef({
    front: null,
    left: null,
    rear: null,
    right: null,
  });

  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);

  const togglePlay = useCallback(() => {
    setPlaying((prev) => !prev);
  }, []);

  const handleProgress = useCallback((progress) => {
    setProgress(progress.playedSeconds);
    Object.entries(players.current).forEach(([key, player]) => {
      if (key !== "front" && player) {
        player.seekTo(progress.playedSeconds, "seconds");
      }
    });
  }, []);

  const handleSeek = useCallback((offset) => {
    const newTime = Math.max(progress + offset, 0);
    setProgress(newTime);

    Object.values(players.current).forEach((player) => {
      if (player) {
        player.seekTo(newTime, "seconds");
      }
    });
  }, [progress]);

  const handleDuration = useCallback((duration) => {
    setDuration(duration);
  }, []);

  const formatTime = (time) => {
    if (!time || isNaN(time)) return "00:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };
  
  return (
    <div style={{ textAlign: "center", height: "900px", display: "flex", flexDirection: "column" }}>
      <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between' }}>
        <h4 style={{ alignSelf: "flex-start" }}> {scenarioName}</h4>
        <Button
          onClick={() => closeDialog(false)}
          variant="outlined"
          style={{ marginRight: "1rem", backgroundColor: "rgb(98, 42, 216)", color: "white" }}
        >
          Close
        </Button>

      </div>
      <Divider style={{ marginTop: "15px", color: "rgb(98, 42, 216)", backgroundColor: "rgb(98, 42, 216)" }} />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "auto auto",
          gap:'10px 10px',
          height: '700px',
          width: '1000px',
          textAlign: 'center',
          justifyItems: 'center',
          justifyContent: 'center',
          margin: 'auto'
        }}
      >
        {Object.entries(videoUrls).map(([key, url]) => {
          return (
            <Card style={{minWidth:"400px"}}>
              <CardHeader title={key.toUpperCase()}></CardHeader>
              {url !== null &&
                <CardMedia>
                  <ReactPlayer
                  key={key}
                  ref={(player) => (players.current[key] = player)}
                  url={url}
                  playing={playing}
                  onProgress={key === "front" ? handleProgress : undefined}
                  onDuration={key === "front" ? handleDuration : undefined}
                  width="100%"
                  height="100%"
                  controls={false}
                  muted
                />
                </CardMedia>
              }

              {url === null && <CardContent style={{ height: "100%", width: "100%" }}>Video not available</CardContent>}
            </Card>
          )
        })}
      </div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ marginBottom: "10px", width: "15%" }}>

          <Tooltip placement="top" title="Rewind 5 seconds">

            <IconButton aria-label="delete" onClick={() => handleSeek(-5)}>
              <Replay5Icon fontSize="large" />
            </IconButton>
          </Tooltip>

          <Tooltip placement="top" title={playing ? "Pause" : "Play"}>

            <IconButton aria-label="delete" onClick={togglePlay}>
              {playing ? <PauseCircleFilledIcon fontSize="large" /> : <PlayCircleFilledIcon fontSize="large" />}


            </IconButton>
          </Tooltip>
          <Tooltip placement="top" title="Forward 5 seconds">
            <IconButton aria-label="delete" onClick={() => handleSeek(5)}>
              <Forward5Icon fontSize="large" />
            </IconButton>
          </Tooltip>

        </div>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", width: "85%" }}>
          <span>{formatTime(progress)}</span>         <input
            type="range"
            min={0}
            max={duration}
            value={progress}
            step={0.1}
            onChange={(e) => handleSeek(parseFloat(e.target.value) - progress)}
            style={{ flexGrow: 1 }}
          />
          <span>{formatTime(duration)}</span>
        </div>
      </div>
    </div>
  );
};

export default CMSyncedVideoPlay;
